import { ResponsiveLocationIcon } from "../../styles/commonStyles";

type IconProps = {
  color?: string;
  width?: number;
  height?: number;
};

export const LocationIcon = ({
  color = 'currentColor',
  width = 18,
  height = 18,
}: IconProps) => (
  <ResponsiveLocationIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      width: width,
      height: height,
    }}
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </ResponsiveLocationIcon>
);